import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';
import ContentBlock from '@bitcoin-portal/bitcoincom-pkg-components/dist/ContentBlock';

// TypeScript interface for MobileSectionContent props
interface MobileSectionContentProps {
  isExpanded: boolean;
}

export const StyledSection = styled(Section)`
  order: 9;
  display: flex;
  width: 100%;

  overflow: visible;
  background: var(--Grey-Scale-900, #1c1c1c);

  padding: 0px !important;
  margin: 40px 0px !important;
  margin-bottom: 0px !important;
`;

export const StyledContentBlock = styled(ContentBlock)`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  background: var(--Grey-Scale-900, #1c1c1c);
  max-width: unset !important;
`;

export const Mainwrapper = styled.div`
  display: none;

  ${media.lg`{
    display: flex;
    padding: 75px 0px 25px 0px;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--small, 75px);
    width: 100%;
    
  `}
`;

export const FooterGrid = styled.div`
  display: grid;

  grid-template-columns: repeat(5, 1fr);

  grid-template-areas:
    'download company educate products follow'
    'download get-crypto spend-crypto crypto-games exchanges'
    'download bitcoin-data bitcoin-games . .';
  gap: 80px 40px;
  width: 100%;

  & > div:nth-child(1) {
    grid-area: download;
  }

  & > div:nth-child(2) {
    grid-area: company;
  }

  & > div:nth-child(3) {
    grid-area: educate;
  }

  & > div:nth-child(4) {
    grid-area: products;
  }

  & > div:nth-child(5) {
    grid-area: bitcoin-data;
  }

  & > div:nth-child(6) {
    grid-area: get-crypto;
  }

  & > div:nth-child(7) {
    grid-area: spend-crypto;
  }

  & > div:nth-child(8) {
    grid-area: crypto-games;
  }

  & > div:nth-child(9) {
    grid-area: exchanges;
  }

  & > div:nth-child(10) {
    grid-area: bitcoin-games;
  }

  & > div:nth-child(11) {
    grid-area: follow;
  }

  ${media.xl`
    grid-template-columns: repeat(6, 1fr);
    
    grid-template-areas:
      'download company educate products bitcoin-data follow'
      'download get-crypto spend-crypto crypto-games exchanges bitcoin-games';
  `}
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;

export const ColumnTitle = styled.h3`
  color: #fff;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  margin: 0 0 10px 0;
`;

export const LinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LinkItem = styled.li`
  margin: 0;
`;

export const StyledLink = styled.a`
  color: var(--Type-body-copy-dark, #6b6d7b);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export const Googleplay = styled.div`
  display: flex;
  height: 50px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: var(--radius-xsml, 10px);
  border: 1px solid var(--Type-body-copy-light, #797b8b);
`;

export const Appstore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  align-self: stretch;
  border-radius: var(--radius-xsml, 10px);
  border: 1px solid var(--Type-body-copy-light, #797b8b);
`;

export const Storewrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  width: 100%;
`;

export const Downloadappwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 23px;
`;

export const Downwrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 157px;
  align-self: stretch;
`;

export const Logocontentwrapper = styled.div`
  display: flex;
  padding-right: 0.001px;
  justify-content: center;
  align-items: center;
  gap: 23.83px;
  width: 40%;
`;

export const Bitcoinlogowrapper = styled.div`
  width: 97.475px;
  height: 97.475px;
  flex-shrink: 0;
`;

export const GoogleplayImagewrapper = styled.div`
  width: 114.104px;
  height: 26.533px;
  cursor: pointer;
`;

export const SelectContainer = styled.div`
  & > div {
    height: 48px;
  }

  .mlt-select__indicators {
    height: 48px !important;
  }

  ${media.md`
    margin-bottom: 0;

    & > div {
      height: 32px;
      width: 152px;
    }

    .mlt-select__indicators {
      height: 32px !important;
    }
  `}

  ${media.lg`
    & > div {
      width: 180px;
    }
  `}
`;

export const AppstoreImagewrapper = styled.div`
  width: 107.008px;
  height: 28.507px;
  cursor: pointer;
`;

export const Footerwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 23px;
`;

export const Copyright = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 30%;
`;

export const Coprrighttext = styled.p`
  color: var(--Grey-Scale-500, #96949c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 109%;
  margin: 0px;
`;

export const Support = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 20%;
`;

export const Supporttext = styled.p`
  color: var(--Grey-Scale-500, #96949c);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 109%;
  margin: 0px;
`;

export const Supporttextorange = styled.p`
  color: var(--orange-500, #ff9500);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 109%;
  margin: 0px;
`;

export const MobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 40px;
  ${media.lg`
    display: none;
    
  `}
`;

export const MobileSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 24px;
  border-bottom: 1px solid var(--Type-body-copy-light, #797b8b) !important;
  cursor: pointer;
`;

export const MobileDownloadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--radius-sml, 20px);
  align-self: stretch;
`;

export const MobileSectionSeparator = styled.div`
  height: 1px;
  background: var(--Type-body-copy-light, #797b8b);
`;

export const MobileSectionTitle = styled.h3`
  color: #fff;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 110%;
  margin: 0;
  flex: 1 0 0;
`;

export const ToggleIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 31px;
  height: 30px;
  border-radius: 50%;
  background-color: #ff9500;
`;

export const MobileSectionContent = styled.div<MobileSectionContentProps>`
  width: 100%;
  padding: 16px 24px;
  display: ${props => (props.isExpanded ? 'block' : 'none')};
`;

export const MobileLinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const MobileLinkItem = styled.li`
  margin: 0;
`;

export const MobileLink = styled.a`
  color: var(--Type-body-copy-dark, #6b6d7b);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  text-decoration: none;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export const MobileAppButton = styled.a`
  display: flex;
  height: 56px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 112px;
  border: 1px solid var(--Type-body-copy-dark, #6b6d7b);
  background: #fff;
  text-decoration: none;
`;

export const MobileAppImageWrapper = styled.div`
  width: 114px;
  height: 26px;
`;

export const MobileFooterBottom = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  padding-top: 40px;
  padding-bottom: 40px;
`;

export const MobileLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-bottom: 16px;
`;

export const MobileCopyright = styled.p`
  color: #96949c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-align: start;
  margin: 0;
`;

export const MobileSupport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: 8px;
`;

export const MobileSupportText = styled.p`
  color: #96949c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  margin: 0 0 4px 0;
`;

export const MobileSupportEmail = styled.a`
  color: #ff9500;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-decoration: none;
`;

export const LogoImage = styled.img`
  width: 277px;
  height: 58px;

  ${media.xl`
    width: 464px;
    height: 98px;
  `}
`;
